import React from 'react';
import footerData from './FooterData';
import styles from './Footer.module.scss';
import { classNameGenerator } from '@/utils';
import Typography from '@/foundation/Typography/V2';
import { ShyftLogo } from '@/components/Organisms/Navbar/Header/style';
import theme from '@/foundation/Theme';

const Footer = () => {
  const { brand, sections, copyright, tagline } = footerData;
  const cls = classNameGenerator(styles);

  const logo = (
      <Typography variant="routelink2" to="/">
        <ShyftLogo
          icon="icon-brand-logo-light"
          fill={theme.colors.white}
          className="homepagelogo"
        />
      </Typography>
    );

  return (
    <footer id="footer" className={cls('main-footer')}>
      <div className={cls('footer-top')}>
        <div className={cls('brand-info')}>
          {logo}
          <p className={cls('description')}>{brand.description}</p>
        </div>

        <div className={cls('links-container')}>
          {sections.map((section, idx) => (
            <div key={idx} className={cls('footer-section')}>
              <h3 className={cls('section-title')}>{section.title}</h3>
              <ul>
                {section.links.map((link, lIdx) => (
                  <li key={lIdx}>
                    <a href={link.url}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className={cls('footer-bottom')}>
        <div className={cls('bottom-content')}>
          <p className={cls('copyright')}>{copyright}</p>
          <p className={cls('tagline')}>{tagline}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;